import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Analytics from '../../analytics/Analytics';
import withEinstein from '../withEinstein/containers/withEinstein';
import RecommendedProducts from '../../shared/components/RecommendedProducts/RecommendedProducts';


class ProductRecommendedProducts extends Component {
  static getDomId() {
    return 'slot_product_recommended_products';
  }

  static getFallbackDetails() {
    return {
      delay: 5000,
      url: `${window.seMarketplace.site_globals.profferUrl}?type=einsteinFallback`,
    };
  }

  constructor(props) {
    super(props);
    this.analytics = new Analytics();
    this.getFallbackProducts = this.getFallbackProducts.bind(this);
  }

  getFallbackProducts() {
    const { productIds } = this.props;

    if (productIds) {
      return productIds.map(id => id.details);
    }
    return null;
  }

  render() {
    const { recommendedProducts, details } = this.props;
    const props = {
      ...details,
      recommendedProducts: recommendedProducts || this.getFallbackProducts(),
    };

    return (
      <RecommendedProducts
        {...props}
        analytics={this.analytics}
        list="Productpage Recommended Products"
      />
    );
  }
}

ProductRecommendedProducts.propTypes = {
  details: PropTypes.shape({}),
  recommendedProducts: PropTypes.arrayOf(PropTypes.shape({
    productID: PropTypes.string,
  })),
  productIds: PropTypes.arrayOf(PropTypes.shape({})),
};

ProductRecommendedProducts.defaultProps = {
  details: {},
  productIds: undefined,
  recommendedProducts: undefined,
};

export default withEinstein(ProductRecommendedProducts);
